import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isPriviliged } from '../../../core/deviceHelper';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import s from '../Popup.css';
import { setDeviceCommandValue, removeProtectedInstallation } from '../../../actions/device';
import Messages from '../Messages';
import Icon from '../../Icon';
import Loader from '../../Loader';
import ConnectedDevicesCommon from './ConnectedDevicesCommon';

class ConnectedDevicesSoftenerXSafeTech extends ConnectedDevicesCommon {

	deleteDevice = (installation_id, serial) => {
		if (installation_id){
			this.props.removeProtectedInstallation(installation_id, serial);
		}
	}

	render() {
		const {device, userRole, serial} = this.props;
		const messages = Messages();
		const installation = device.get('installation')
	    const softeners = ['softener', 'charlie', 'simplex'];
	    const softenerDevice = softeners.indexOf(device.get('device_type_name')) >= 0;

		if (installation){
			if (softenerDevice){
				return (
				  <div>
				    <FormattedMessage {...messages.pairing_connected_safetech_to_softeners_text} />
				    <ul>
						{installation.map((item, index) => this.showText(item, userRole))}
					</ul>
				  </div>
				)
			} else {
				return (
				  <div>
				    <FormattedMessage {...messages.pairing_connected_softeners_to_safetech_text} />
				    <ul>
						{installation.map((item, index) => this.showText(item, userRole))}
					</ul>
				  </div>
				)
			}
		} else {
			return null;
		}
	

	}
}



ConnectedDevicesSoftenerXSafeTech.propTypes = {
  userRole: PropTypes.string.isRequired,
  setDeviceCommandValue: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  serial: PropTypes.string.isRequired
};


const mapDispatch = dispatch => {
  return {
    setDeviceCommandValue: (deviceId, command, value) => 
      dispatch(setDeviceCommandValue(deviceId, command, value)),
    removeProtectedInstallation:(installation_id, action) => 
    	dispatch(removeProtectedInstallation(installation_id, action)),
  };
};

export default injectIntl(
  compose(connect(null, mapDispatch), withStyles(s))
  (ConnectedDevicesSoftenerXSafeTech)
);



// WEBPACK FOOTER //
// ./src/components/Popup/DevicePopups/ConnectedDevicesSoftenerXSafeTech.js